import { render, staticRenderFns } from "./StepLogistics.vue?vue&type=template&id=bf8cbf3a&scoped=true"
import script from "./StepLogistics.vue?vue&type=script&lang=js"
export * from "./StepLogistics.vue?vue&type=script&lang=js"
import style0 from "./StepLogistics.vue?vue&type=style&index=0&id=bf8cbf3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8cbf3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf8cbf3a')) {
      api.createRecord('bf8cbf3a', component.options)
    } else {
      api.reload('bf8cbf3a', component.options)
    }
    module.hot.accept("./StepLogistics.vue?vue&type=template&id=bf8cbf3a&scoped=true", function () {
      api.rerender('bf8cbf3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/components/StepLogistics.vue"
export default component.exports